import Page from "../../components/PageContainer/Page";
import SectionDivider from "../../components/common/SectionDivider/SectionDivider";
import styles from "./About.module.scss";
import PropTypes from "prop-types";
import { VisibilityOutlined, WorkOutline } from "@mui/icons-material";
import AnimatedWrapper from "../../components/common/AnimatedWrapper/AnimatedWrapper";
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const About = ({ onPageChange }) => {
  const { t } = useTranslation();
  return (
    <Page name="about" background="white">
      <div className={styles.about}>
        <div className={styles.about__header}>
          <AnimatedWrapper>
          <p className={styles["about__header--subtitle"]}>{t('about.subtitle')}</p>
          </AnimatedWrapper>
          <AnimatedWrapper>
          <h2 className={styles["about__header--title"]}>{t('about.title')}</h2>
          </AnimatedWrapper>
          <AnimatedWrapper>
          <SectionDivider />
          </AnimatedWrapper>
          <p className={styles["about__header--description"]}>
            {t('about.description')}
          </p>
        </div>

        <div className={styles.about__content}>
          <div className={styles.about__image}>
            <AnimatedWrapper delay={0.2}>
              <img src="/dariusz-army.jpg" alt="Dariusz Szymczak" />
            </AnimatedWrapper>
          </div>

          <div className={styles.about__description}>
            <AnimatedWrapper delay={0.4}>
              <h3 className={styles["about__description--title"]}>
                {t('about.profile_title')}
              </h3>
              <p className={styles["about__description--text"]}>
                {t('about.profile_text')}
              </p>
            </AnimatedWrapper>
          </div>

          <div className={styles.about__info}>
            <AnimatedWrapper delay={0.6}>
              <div className={styles["about__info--details"]}>
                <div className={styles["about__info--item"]}>
                  <span>{t('about.info.name')}</span>
                  <span>Dariusz Szymczak</span>
                </div>
                <div className={styles["about__info--item"]}>
                  <span>{t('about.info.email')}</span>
                  <span>dariuszszymczak.work@gmail.com</span>
                </div>
                <div className={styles["about__info--item"]}>
                  <span>{t('about.info.phone')}</span>
                  <span>+48 692 683 155</span>
                </div>
                <div className={styles["about__info--item"]}>
                  <span>{t('about.info.nationality')}</span>
                  <span>{t('about.info.nationality_value')}</span>
                </div>
                <div className={styles["about__info--item"]}>
                  <span>{t('about.info.address')}</span>
                  <span>{t('about.info.address_value')}</span>
                </div>

                <div className={styles["about__info--item"]}>
                  <span>{t('about.info.github')}</span>
                  <a
                    href="https://www.github.com/DariuszSzymczak"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    github.com/DariuszSzymczak
                  </a>
                </div>
                <div className={styles["about__info--item"]}>
                  <span>{t('about.info.linkedin')}</span>
                  <a
                    href="https://www.linkedin.com/in/dariuszszymczak/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    linkedin.com/in/dariuszszymczak
                  </a>
                </div>
              </div>
              <div className={styles["about__info--buttons"]}>
                <Link
                  to="/cv"
                  className={styles.button}
                  onClick={() => onPageChange && onPageChange('cv')}
                >
                  <VisibilityOutlined sx={{ marginRight: "8px" }} />
                  {t('about.buttons.check_cv')}
                </Link>
                <a
                  href="#contact"
                  className={`${styles.button} ${styles["button--secondary"]}`}
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  <WorkOutline sx={{ marginRight: "8px" }} />
                  {t('about.buttons.hire_me')}
                </a>
              </div>
            </AnimatedWrapper>
          </div>
        </div>
      </div>
    </Page>
  );
};

About.propTypes = {
  onPageChange: PropTypes.func,
};

About.defaultProps = {
  onPageChange: undefined,
};

export default About;
